import {createActions} from 'client/framework';

export default createActions(null, [
  'SET_SEARCH_STRING',
  'SET_SELECTED_OPTION',
  'SET_IS_DROPDOWN_OPEN',
  'SET_IS_OPEN_ON_FOCUS',
  'RESET_STORE'
]);
